import React, { useEffect, useState } from "react";
import Template from "../utils/Template";
import Card from "../utils/Card";
import TableScroll from "../utils/TableScroll";
import { Table, TableBody, TableHeader } from "../utils/Table";
import { getMethod } from "../service";
import { decodeData, errorToaster, formatDate } from "../utils/Helper";
import { RESULTS_API } from "../service/constant";
import DateRangeFormat from "../utils/DateRangeFormat";
import SubmitBtn from "../utils/SubmitBtn";
import Pagination from "../utils/Pagination";

const Results = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [totalPage, setTotalPage] = useState(1);
  const [page, setPage] = useState(1);
  const [from, setFrom] = useState(1);
  const [refs, setRefs] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchResults = async () => {
    setIsLoading(true);
    const token = decodeData(localStorage.getItem("r_c_a"));
    if (token) {
      try {
        const res = await getMethod(
          `${RESULTS_API}?page=${page}&limit=50&start_date=${startDate}&end_date=${endDate}`,
          token.token
        );
        if (res?.isSuccess) {
          setResults(res?.data);
          setFrom((res.meta?.current_page - 1) * 50);
          setTotalPage(res.meta?.last_page);
        } else {
          errorToaster("Failed to fetch results");
        }
      } catch (error) {
        errorToaster("An error occurred");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      errorToaster("Unauthenticated!");
    }
  };

  useEffect(() => {
    fetchResults();
  }, [refs, page]);

  return (
    <Template title={"Results"} isLoading={isLoading}>
      <Card>
        <div className="row d-flex justify-content-end">
          <div className="col-12 col-md-4 px-1 mb-3">
            <DateRangeFormat
              setStartDate={setStartDate}
              setEndDate={setEndDate}
            />
          </div>
          <div className="col-12 col-md-4 px-1 mb-3">
            <SubmitBtn
              type={"submit"}
              name={"Search"}
              event={() => setRefs(!refs)}
              isLoading={isLoading}
            />
          </div>
        </div>
        <TableScroll>
          <Table>
            <TableHeader>
              <th>No.</th>
              <th>Number</th>
              <th>Odds</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Created At</th>
            </TableHeader>
            <TableBody>
              {results.length > 0 &&
                results.map((result, i) => (
                  <tr key={result._id} style={{ verticalAlign: "middle" }}>
                    <td>{i + 1 + from}.</td>
                    <td>{result?.number}</td>
                    <td className="text-end">{result?.odds}</td>
                    <td>{formatDate(result?.start_time)}</td>
                    <td>{formatDate(result?.end_time)}</td>
                    <td>{formatDate(result?.createdAt)}</td>
                  </tr>
                ))}
            </TableBody>
          </Table>
        </TableScroll>
        {totalPage > 1 && (
          <div className="d-flex justify-content-end">
            <Pagination
              setPage={setPage}
              setIsLoading={setIsLoading}
              totalPage={totalPage}
            />
          </div>
        )}
      </Card>
    </Template>
  );
};

export default Results;
